import React from "react";
import { Autocomplete, Avatar, Box, TextField, Typography } from "@mui/material";
import { ImageOutlined } from "@mui/icons-material";

/**
 * Select pesquisável de um destino de ping (preset/ícone) para um slot (A–E).
 * - `value`: preset selecionado (objeto de anexo type=ping_icon) ou null.
 * - `options`: lista de presets disponíveis (pingIcons).
 * - Se o `value` não existir em `options` (ex.: valor antigo do host sem preset
 *   correspondente, montado como opção sintética), ele é incluído para preservar
 *   e exibir o valor atual.
 */
export default function PingPresetSelect({
  index,
  value = null,
  options = [],
  onChange = () => {},
}) {
  const slotLabel = `Destino ${String.fromCharCode(65 + index)}`;

  const finalOptions =
    value && !options.some((p) => p.id === value.id)
      ? [value, ...options]
      : options;

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={finalOptions}
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      getOptionLabel={(o) => o?.descricao || ""}
      isOptionEqualToValue={(o, v) => o?.id === v?.id}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          key={option.id}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Avatar
            variant="rounded"
            src={option.imageUrl}
            sx={{ width: 24, height: 24 }}
          >
            <ImageOutlined fontSize="small" />
          </Avatar>
          <Box>
            <Typography variant="body2">
              {option.descricao || "Sem descrição"}
            </Typography>
            {option.metadata?.destino && (
              <Typography variant="caption" color="text.secondary">
                {option.metadata.destino}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      renderInput={(params) => <TextField {...params} label={slotLabel} />}
    />
  );
}
